/**
 * Created by 58 on 2016/9/28.
 */
/*require('./../../style/contact-group-detail.less');*/
var Component = require('./../Component'),
  $ = require('jQuery'),
  template = require('../../template/contact-group-detail.html'),
  SessionList = require('./SessionList'),
  Scrollbar = require('./../Scrollbar'),
  timeFormatter = require('../../utils/timeFormatter');

var SessionGroup = function(options) {
  (function(self) {
    var defaults = {
      template: template
    };
    $.extend(defaults, options);
    Component.call(self, defaults);
  })(this);

  /*
   * 添加sessionlist , scrollbar
   * */
  (function(self) {
    var sessionlist = new SessionList({
      is_group: true
    });
    self._element.find('.im-contact-group-detail-body').append(sessionlist.getElement());
    self._children['session-list'] = sessionlist;

    var scrollbar = new Scrollbar({
      window: self._element.find('.im-contact-group-detail-body'),
      content: self._element.find('.im-session-list')
    });
    self._element.find('.im-contact-group-detail-body').append(scrollbar.getElement());
    self._children['scrollbar'] = scrollbar;

    scrollbar.addEventListener('scrolled', function(scrolltop) {
      var wrapHeight = self.getElement().find('.im-contact-group-detail-body').height();
      var listHeight = self.getElement().find('.im-session-list').height();
      if (listHeight < wrapHeight) {
        return false
      }
      if (listHeight - wrapHeight - scrolltop <= 5) {
        self._children['session-list'].addLoading();
      }
    });
    setTimeout(function() {
      scrollbar.init();
      scrollbar.calHeight();
    }, 0);
  })(this);

  /*
   * 点击返回
   * */
  (function(self) {
    self._element.find('.im-backto-contactlist').click(function() {
      self.triggerEvent('return', self._data);
    });
  })(this);
};
SessionGroup.prototype = Object.create(Component.prototype);

SessionGroup.prototype.render = function() {
  let self = this;
  if (!this._data.session)
    return;

  var session = this._data.session;
  if (!session.group)
    return;

  var group = this._data.session.group;
  this._element.find('.im-contact-group-msg').text(group.name);

  var msg = this._data.session.msg;
  var time = msg ? timeFormatter(msg.send_time) : '';

  this._element.find('.im-contact-group-time').text(time);
  this._children['session-list'].empty();
  this._children['session-list'].setSessions(session.children, function() {
    self._children['scrollbar'] && self._children['scrollbar'].calHeight();
  });
};

SessionGroup.prototype.setSession = function(session) {
  this.setData({
    session: session
  });
};

module.exports = SessionGroup;
